// extracted by mini-css-extract-plugin
export default {"hr":"hr_hr__PNlfs"};